<div *ngIf="symbolTpl" class="symbol">
  <div layout>
    <ng-container *ngTemplateOutlet="symbolTpl"></ng-container>
  </div>
</div>

<a *ngIf="href" [href]="href" class="name" layout-align-items-center>
  <rt-truncate>{{ name }}</rt-truncate>
</a>
<div *ngIf="!href" class="name" layout-align-items-center>
  <rt-truncate>{{ name }}</rt-truncate>
</div>

<div *ngIf="deletable" (click)="deleteTag($event, name)" class="delete">
  <rt-icon name="close" [style.height]="'auto'"></rt-icon>
</div>

<div *ngIf="counter" class="counter">
  <span>{{ counter }}</span>
</div>
